import React from 'react';

const CircularProgress = ({
    value,
    max = 100,
    size = 120,
    strokeWidth = 10,
    centerContent,
    color = "#881337",
    backgroundColor = "#F3E8E0"
}) => {
    const radius = (size - strokeWidth) / 2;
    const circumference = radius * 2 * Math.PI;
    const offset = circumference - (value / max) * circumference;

    return (
        <div className="relative inline-flex items-center justify-center">
            <svg className="transform -rotate-90" width={size} height={size}>
                {/* Background circle */}
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    stroke={backgroundColor}
                    strokeWidth={strokeWidth}
                    fill="transparent"
                />
                {/* Progress circle */}
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    stroke={color}
                    strokeWidth={strokeWidth}
                    fill="transparent"
                    strokeDasharray={circumference}
                    style={{
                        strokeDashoffset: offset,
                        transition: 'stroke-dashoffset 0.5s ease-in-out',
                        strokeLinecap: 'round'
                    }}
                />
            </svg>
            <div className="absolute inset-0 flex flex-col items-center justify-center text-center">
                {centerContent || (
                    <span className="text-2xl font-black text-[#111827]">
                        {Math.round((value / max) * 100)}%
                    </span>
                )}
            </div>
        </div>
    );
};

export default CircularProgress;
